<template>
    <CreatePopup v-if="messageHouseDialog" v-model="messageHouseDialog" :flowtype="'Message House'" @create="addMessageHouse($event)"/>
    <div class="message-house-container">
      
        <div v-if="pageLoader" class="no-data">
            <RotatingLoader :size="30" :speed="0.6" label="Loading..." />
        </div>
        <div v-else class="message-house">
            <div class="TitleSection">
                <div class="title">Message House</div>
                <button v-if="messageHouseList.length > 0" @click=" messageHouseDialog = true" class="new-msg-house-container">
                    <Svg :src="require('@/assets/icons/add.svg')" alt="add"></Svg>
                    <span>Create</span>
                </button>
            </div>
            <div v-if="documentCount ===0 && !filterState" class="no-message-house">
                <EmptyState :title="'No Message House Created!'"
                    :subTitle="'Create a new Message House to see it listed here.'" :stage="'DRAFT'"
                    @create-dialog="messageHouseDialog = true"></EmptyState>
            </div>
            <div v-else class="mid-section">
                <div class="toggle-container">
                    <div class="toggle-buttons">
                        <button class="toggle-button active">
                            <div class="toggle-header">All Documents <span>({{ documentCount }})</span></div>
                        </button>
                    </div>
                    <div class="filter-Page">
                        <v-menu v-model="dateMenu" :close-on-content-click="false">
                            <template v-slot:activator="{ props }">
                                <div class="selected-date-container">
                                    <button class="filter-btn" v-bind="props">
                                        <Svg :src="require('@/assets/icons/calendar.svg')" stroke='#030712'></Svg>
                                        <span v-if="displayDateValue">{{ displayDateValue }}</span>
                                        <span class="text" v-else>Filter by Date</span>
                                    </button>
                                    <v-icon v-if="filterStartDate" @click="clearFilterDates">mdi-close</v-icon>
                                </div>
                            </template>
                            <v-date-picker v-model="selectedDate" :max="new Date()" multiple="range"
                                @update:model-value="updateFilterDate(false)">
                                <template #actions>
                                    <div class="action-btns">
                                        <v-btn @click="clearFilterDates" class="ok-btn">Cancel</v-btn>
                                        <v-btn @click="updateFilterDate(true)" class="ok-btn"
                                            :disabled="selectedDate.length === 0">OK</v-btn>
                                    </div>
                                </template>
                            </v-date-picker>
                        </v-menu>

                        <div class="view-toggle-container">
                            <button @click="selectedView = 'list'"
                                :class="{ 'active': selectedView === 'list', 'view-icon': true }">
                                <Svg :src="require('@/assets/icons/list.svg')"></Svg>
                            </button>
                            <button @click="selectedView = 'grid'"
                                :class="{ 'active': selectedView === 'grid', 'view-icon': true }">
                                <Svg :src="require('@/assets/icons/grid.svg')"></Svg>

                            </button>

                        </div>

                    </div>
                </div>
                <RenamePopup v-if="isEditing" :docName="currentRenameItem.title" :id="currentRenameItem.msgHouseId"
                    :isEditing="isEditing" @update-isEdit="isEditing = $event"
                    @updated-prTitle="handleTitleUpdate($event)" flowType="messageHouse" />
                 <div v-if="pageLoader" class="no-data">
                  <RotatingLoader :size="30" :speed="0.6"/>

                </div>
                <div v-if="documentCount === 0 && filterState" class="no-press-release">
                    <EmptyState :title="'No Message House!'":stage="'COMPLETED'"
                        :subTitle="'No Mesage house match your filters'"
                        @create-dialog="newPrDialog = true">
                    </EmptyState>
                </div>
                <div class="table-container" v-else-if="selectedView === 'list' && messageHouseList.length > 0">
                    <v-data-table class="table-wrapper" :headers="messageHouseTableHeaders" :items="messageHouseList"
                        :hover="true" :items-per-page="itemsPerPage" :page="page"
                        @click:row="redirectToMessageHouseDetails">
                        <template v-slot:[`item.createdByName`]="{ item }">
                            <div class="avatar">
                                <img v-if="item.profileAvatar" :src="item.profileAvatar" class="profile-icon"
                                    alt="User Avatar" />
                                <div class="profile-icon no-avatar" v-else>{{ item?.createdByName?.[0] }}</div>
                                <div class="author">{{ item.createdByName }}</div>
                            </div>
                        </template>
                        <template v-slot:[`item.createdAt`]="{ item }">
                            {{ convertEpochToDate(item.createdAt) }}
                        </template>
                        <template v-slot:[`item.updatedAt`]="{ item }">
                            {{ convertEpochToDate(item.updatedAt) }}
                        </template>
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-menu v-model="item.showMoreMenu" :close-on-content-click="false">
                                <template v-slot:activator="{ props }">
                                    <div class="more-button-wrapper">
                                        <img style="height: 16px; width: 16px;"
                                            :src="require('@/assets/icons/more.svg')" alt="more" v-bind="props">
                                    </div>
                                </template>
                                <div class="more-options-contaioner">
                                    <div @click="editMsgHouse(item)"
                                        class="bottom-border more-option-img-wrapper">
                                        <img :src="require('@/assets/icons/rename.svg')" alt="rename">
                                        <p>Rename</p>
                                    </div>
                                    <div class="more-option-img-wrapper" @click="deleteMessageHouse(item)">
                                        <Svg :src="require('@/assets/icons/delete.svg')" fill='#404040'
                                            alt="delete"></Svg>
                                        <p>Delete</p>
                                    </div>
                                </div>
                            </v-menu>
                        </template>
                    </v-data-table>
                </div>
                <div class="pr-grid" v-else-if="selectedView === 'grid' && messageHouseList.length > 0">
                    <div v-for="(item, index) in messageHouseList" :key="index" class="pr-card"
                        @click="redirectToMessageHouseDetails(event, { item })">
                        <div class="pr-more-container">
                            <div class="pr-content">{{ item.title }}</div>
                            <div class="more-container">
                                <v-menu v-model="item.showMoreMenu" :close-on-content-click="false">
                                    <template v-slot:activator="{ props }">
                                        <img :src="require('@/assets/icons/more.svg')" alt="more" v-bind="props">
                                    </template>
                                    <div class="more-options-container">
                                        <div @click="editMsgHouse(item)"
                                            class="bottom-border more-option-img-wrapper">
                                            <img :src="require('@/assets/icons/rename.svg')" alt="rename">
                                            <p>Rename</p>
                                        </div>
                                        <div class="more-option-img-wrapper" @click="deleteMessageHouse(item)">
                                            <Svg :src="require('@/assets/icons/delete.svg')" fill='#404040'
                                                alt="delete"></Svg>
                                            <p>Delete</p>
                                        </div>
                                    </div>
                                </v-menu>
                            </div>
                        </div>
                        <div class="pr-footer">
                            <div class="avatar">
                                <img v-if="item.profileAvatar" :src="item.profileAvatar" class="profile-icon"
                                    alt="User Avatar" />
                                <div class="profile-icon no-avatar" v-else>{{ item?.createdByName?.[0] }}</div>
                                <div class="author">{{ item.createdByName }}</div>
                            </div>
                            <div class="meta-info">
                                <div class="timestamp">{{ convertUpdatedTime(item.updatedAt).date }}</div>
                                <div class="seperator"></div>
                                <div class="timestamp">{{ convertUpdatedTime(item.updatedAt).time }}</div>

                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="no-data">
                    No Message House Available!
                </div>
            </div>
        </div>
    </div>
    <CommonPopup v-if="showCommonPopup" :showCommonPopup="showCommonPopup" :popupType="popupType"
        @confirm-action="handleConfirmation" />
    <ConfirmPopup v-if="confirmPopup" v-model="confirmPopup" :title="'Message House discarded'" :image="deleteImage"
        :type="'success'" />
</template>
<script>
import EmptyState from '@/components/EmptyState.vue';
import axiosInstance from '@/axiosInterceptor';
import moment from 'moment-timezone';
import { Eventbus } from '@/plugins/eventBus';
import RotatingLoader from '@/components/CircularProgressBar.vue'
import CommonPopup from '@/components/CommonPopup.vue';
import RenamePopup from '@/components/RenamePopup.vue';
import { isEmpty } from 'vuetify/lib/util';
import ConfirmPopup from '@/components/ConfirmPopup.vue';
import FinalMessageHouse from './FinalMessageHouse.vue';
import CreatePopup from '@/components/CreatePopup.vue';

export default {
    components: {
        EmptyState,RotatingLoader, CommonPopup, RenamePopup, ConfirmPopup, FinalMessageHouse, CreatePopup
    },
    data() {
        return {
            messageHouseDialog: false,
            isFormValid: false,
            messageHouseBtnLoader: false,
            docName: null,
            messageHouseList: [],
            displayDateValue: null,
            filterStartDate: null,
            filterEndDate: null,
            dateMenu: false,
            pageLoader: false,
            messageHouseTableHeaders: [
                { title: 'Title', key: 'title' },
                { title: 'Created By', key: 'createdByName' },
                { title: 'Created Date', key: 'createdAt' },
                { title: 'Last Edited', key: 'updatedAt' },
                { title: 'Actions', key: 'actions' },
            ],
            documentCount: 0,
            selectedView: 'grid',
            selectedDate: [],
            deleteImage: require('@/assets/icons/delete_red.svg'),
            perPage: [
                { name: '5', value: 5 },
                { name: '10', value: 10 },
                { name: '25', value: 25 },
                { name: 'All', value: -1 }
            ],
            page: 1,
            itemsPerPage: 10,
            deletedMsgHouse: null,
            showCommonPopup: false,
            popupType: 'delete',
            isEditing: false,
            currentRenameItem: [],
            confirmPopup: false,
            showFinalMessageHouse: false,
            selectedMsgHouse: null,
            isMsgHouseCompleted: false,
            deletedMsgHouse: null,
            filterState: false,
        }
    },
    watch: {
        messageHouseDialog() {
            if (!this.messageHouseDialog) {
                this.resetPopupData();
            }
        }
    },
    computed: {
        
    },
    methods: {
        resetPopupData() {
            this.docName = null;
        },
        addMessageHouse(docName) {
            this.messageHouseBtnLoader = true;
            const payload = {
                title: docName
            }
            axiosInstance.post('/messageHouse/create', payload)
                .then((response) => {
                    if (response.status === 201) {
                        this.$router.push(`/messageHouse/${response.data.data.msgHouseId}`);
                    }
                })
                .catch((error) => {
                    console.error('Error while creating new Message House: ', error);
                })
                .finally(() => {
                    this.messageHouseBtnLoader = false;
                    this.messageHouseDialog = false;
                })
        },
        async getAllMessageHouses() {
            this.pageLoader = true;
            let payload = {};
            if (this.filterStartDate && this.filterEndDate) {
                payload.startDate = this.filterStartDate;
                payload.endDate = this.filterEndDate;
                this.filterState = true;
            }

            axiosInstance.get('/messageHouse', { params: payload })
                .then((response) => {
                    this.messageHouseList = response.data.data;
                    this.messageHouseList = this.messageHouseList.filter(
                        (item) => item.status === "COMPLETED" || item.status === "DRAFT"
                    ).sort((a, b) => b.updatedAt - a.updatedAt);
                    this.documentCount = this.messageHouseList.length;        
                })
                .catch((error) => {
                    if (error.response.status === 404) {
                        this.messageHouseList = [];
                    } else {
                        Eventbus.emit('commonSnackbar', {
                            snackType: 'error',
                            message: 'Failed to fetch message houses'
                        });
                    }
                })
                .finally(() => {
                    this.pageLoader = false;
                });
        },

        redirectToMessageHouseDetails(event,{item}) {
            this.$router.push({
                    name: 'MessageHouseDetails',
                    params: { msgHouseId: item.msgHouseId }
                });
        },

        editMsgHouse(item) {
            this.isEditing = true;
            this.currentRenameItem = item;
        },

        deleteMessageHouse(item) {
            this.showCommonPopup = true;
            this.deletedMsgHouse = item;
        },

        async handleTitleUpdate(event) {
            this.currentRenameItem.title = event
            await this.getAllMessageHouses();
        },
        async updateFilterDate(okBtnClicked) {
            if (this.selectedDate.length > 1) {
                this.filterStartDate = moment(this.selectedDate[0]).valueOf();
                this.filterEndDate = moment(this.selectedDate[this.selectedDate.length - 1]).valueOf();
                this.displayDateValue = moment(this.selectedDate[0]).format('DD/MM/YYYY') + ' - ' + moment(this.selectedDate[this.selectedDate.length - 1]).format('DD/MM/YYYY');
                this.dateMenu = false;
                this.getAllMessageHouses();
            } else if (okBtnClicked) {
                this.filterStartDate = moment(this.selectedDate[0]).valueOf();
                this.filterEndDate = moment(this.selectedDate[0]).endOf('day').valueOf();
                this.displayDateValue = moment(this.selectedDate[0]).format('DD/MM/YYYY');
                this.dateMenu = false;
                this.getAllMessageHouses();
            }
        },
        clearFilterDates() {
            this.selectedDate = [];
            this.filterStartDate = null;
            this.filterEndDate = null;
            this.dateMenu = false;
            this.displayDateValue = null;
            this.getAllMessageHouses();
        },
        convertUpdatedTime(date) {
            return {
                date: moment(date).format("Do MMM, YYYY"),
                time: moment(date).format("hh:mmA")
            };
        },
        convertUpdatedDate(date) {
            return moment(date).format("Do MMM YYYY");
        },
        convertEpochToDate(time) {
            return moment(time).format('DD/MM/YYYY');
        },
        async handleConfirmation(val){
            this.showCommonPopup = false;
            if (val === 'yes') {
                if (this.popupType === 'delete') {
                    this.deleteLoader = true;
                    axiosInstance.put('/messageHouse/delete', { msgHouseId: this.deletedMsgHouse.msgHouseId})
                        .then((response) => {
                            if (response.status === 204) {
                                this.confirmPopup = true;
                                setTimeout(() => {
                                    this.confirmPopup = false;
                                    this.$router.push({ name: 'MessageHouseHome' });
                                }, 1000);
                                this.getAllMessageHouses();
                            }
                        })
                        .catch((error) => {
                            console.error('Error while deleting ', error);
                            Eventbus.emit('commonSnackbar', {
                                snackType: "failed",
                                message: 'Failed to delete Message House'
                            });
                        })
                        .finally(() => {
                            this.deleteLoader = false;
                            this.deletedMsgHouse = null;
                        })
                }
            }
        }
    },
    async mounted() {
        await this.getAllMessageHouses();

    }

}
</script>
<style scoped>
.message-house-container {
    display: flex;
    background: white;
    gap: 1rem;
    flex-grow: 1;
    border-radius: 16px;
}


.message-house {
    width: 100%;
    height: 100%;
    padding: 2rem;
    gap: 20px;
    display: flex;
    flex-direction: column;

}

.title {
    text-transform: uppercase;
    font-size: 2rem;
    font-weight: bold;
    border-bottom: 16px;
    font-family: 'OverpassMono';
}

.TitleSection {

    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.new-msg-house-container {
    display: flex;
    background: black;
    flex-direction: row;
    color: white;
    border-radius: 8px;
    align-items: center;
    gap: 8px;
    padding: 0em 1.5em;
    font-family: 'OverpassMono';
}

.popup {
    display: flex;
    flex-direction: column;
    background: white;
    border: 1px solid #E0E9ED;
    border-radius: 8px;
}

.toggle-header{
    color: #171717;
    font-size: 16px;
    font-weight: 600;
}

.popup-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    font-weight: 600;
    font-family: 'OverpassMono';
    font-size: 20px;
}

.optional {
    opacity: 0.4;
}

.circle {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    padding: 8px;
    border: 2px solid #D4D4D4;
}

.popup-body {
    display: flex;
    flex-direction: column;
    gap: 4em;
    padding: 16px;
    overflow: auto;
    height: 100%;
}

.popup-footer {
    display: flex;
    justify-content: space-between;
    gap: 1em;
}

.add-new-btn-continue {
    display: flex;
    align-items: center;
    gap: 25px;
    justify-content: center;
    width: 50%;
    background: #171717;
    color: white;
    border: 1px solid #525252;
    border-radius: 8px;
    font-weight: 500;
}

.add-new-btn {
    width: 50%;
    padding: 12px;
    background: white;
    border: 1px solid #525252;
    border-radius: 8px;
    font-weight: 500;
}

button:disabled {
    cursor: not-allowed;
    opacity: 0.7;
}

.popup-input {

    display: flex;
    flex-direction: column;
    gap: 12px;
    font-weight: 500;
}

.no-message-house {
    display: flex;
    flex-direction: column;
    padding: 2rem;
    border: 1px solid #E5E5E5;
    border-radius: 12px;
    background-color: #FAFAFA;
    gap: 20px;
    flex: 1;
    align-items: center;
}

.no-pr-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
    gap: 0.5rem;
}

.no-pr-text {
    font-size: var(--header-font-size);
    font-weight: 600;
}

.no-pr-sub-text {
    font-size: var(--normal-font-size);
    color: var(--dark-grey-color);
}

.toggle-container {
    display: flex;
    justify-content: space-between;
    align-items: center;

}

.filter-Page {
    display: flex;
    gap: 10px;
    justify-content: center;
}

.filter-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
}

.action-btns {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.ok-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #A3A3A3;
    border-radius: 4px;
}

.selected-date-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    height: 40px;
    padding: 4px 8px;
    border-radius: 8px;
    border: 1px solid #D4D4D4;
    color: #030712;
}

.view-toggle-container {
    display: flex;
    border: 1px solid #D4D4D4;
    height: 38px;
    border-radius: 8px;
}

.view-icon {
    display: flex;
    align-items: center;
    padding: 8px 16px;
}

.view-icon.active {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    background-color: #F1F4FB;
}

.view-icon:first-child {
    border-right: 1px solid #D4D4D4;
}

.view-icon.active svg {
    fill: #171717;
}

.author {
    font-weight: 500;
}

.timestamp {
    font-weight: 500;
    color: #A3A3A3
}

.mid-section {
    display: flex;
    flex-direction: column;
    gap: 25px;
    height: 89%;
}

.no-data {
    width: 100%;
    height: 100%;
    padding: 2rem;
    gap: 20px;
    display: flex;
    overflow: auto;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.more-button-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #E5E5E5;
    width: 2rem;
    height: 2rem;
    border-radius: 8px;
}

.more-options-contaioner {
    min-width: 180px;
    display: flex;
    flex-direction: column;
    background: white;
    border: 1px solid #E5E5E5;
    border-radius: 8px;
    box-shadow: 0px 4px 8px 0px #0000000F, 0px 0px 4px 0px #0000000A;
}

.more-option-img-wrapper {
    display: flex;
    gap: 8px;
    align-items: center;
    cursor: pointer;
    padding: 1rem;
}

.table-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 85%;
    justify-content: space-between;

}


.table-wrapper {
    border-radius: 8px;
    height: 100%;
    scrollbar-width: thin;
    justify-content: center;
    will-change: transform;
    align-items: end;
}

.table-container :deep(.v-table__wrapper tr:hover) {
    background: #F1F4FB !important;
}

.table-wrapper :deep(.v-table__wrapper) {
    width: 100%;
    scrollbar-width: thin;
    border: 1px solid #E5E5E5;
    border-radius: 8px;

}

.table-wrapper :deep(.v-table__wrapper thead) {
    position: sticky;
    top: 0;
    z-index: 1000;
    background: #F1F4FB !important;
}

.table-wrapper :deep(.v-table__wrapper thead tr th) {
    font-weight: 600 !important;
    color: var(--primary-font-color);
}

.table-wrapper :deep(.v-table__wrapper tbody) {
    max-height: 800px;
    color: var(--dark-grey-color);
}

.table-wrapper :deep(.v-data-table-footer) {
    background: #F1F4FB !important;
    padding: 0rem 0rem 0rem 1rem;
    margin: 1rem;
    height: 5rem;
    border-radius: 8px;
    border: 1px solid #E5E5E5;
}

.table-wrapper :deep(.v-data-table-footer .v-pagination__list .v-pagination__first) {
    display: none;
}

.table-wrapper :deep(.v-data-table-footer .v-pagination__list .v-pagination__last) {
    display: none;
}

.table-wrapper :deep(.v-data-table-footer .v-input__control) {
    height: 2rem;
    width: 4rem;
}

.table-wrapper :deep(.v-data-table-footer .v-input__control .v-field__input) {
    padding: 0px 16px 8px 16px;
    font-size: 14px;
}

.table-wrapper :deep(.v-data-table-footer .v-input__control .v-field__field) {
    height: 2rem;
    width: 3rem;
}

.table-wrapper :deep(.v-data-table-footer .v-input__control .v-field__append-inner) {
    width: 1rem;
}

.table-wrapper :deep(.v-data-table-footer .v-data-table-footer__items-per-page > .v-select) {
    width: 63px;
    background: #ffffff;
}

.pageLoader-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    /* width: 100%;  */
    gap: 2rem;
}

.avatar {
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 8px;
}

.profile-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    width: 25px;
    height: 25px;
    overflow: hidden;
    font-size: 14px;
}

.no-avatar {
    background: linear-gradient(90deg, #FF00C3, #FF0A19, #FF7800);
    color: white;
}

.pagination-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0.5rem;
}

.pr-grid {
    display: grid;
    overflow: auto;
    scrollbar-width: thin;
    will-change: transform;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 1.5rem;
}

.pr-card {
    display: flex;
    gap: 16px;
    border: 1px solid #E5E5E5;
    background: #FAFAFA;
    flex-direction: column;
    padding: 1rem;
    border-radius: 8px;
    cursor: pointer;
}

.pr-type {
    display: flex;
    width: fit-content;
    align-items: center;
    justify-content: center;
    border-radius: 17px;
    padding: 1px 13px;
}

.pr-more-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.more-options-container {
    min-width: 180px;
    display: flex;
    flex-direction: column;
    background: white;
    border: 1px solid #E5E5E5;
    border-radius: 8px;
    box-shadow: 0px 4px 8px 0px #0000000F, 0px 0px 4px 0px #0000000A;
}

.bottom-border {
    border-bottom: 1px solid #E5E5E5;
}

.more-option-img-wrapper {
    display: flex;
    gap: 8px;
    align-items: center;
    cursor: pointer;
    padding: 1rem;
}

.pr-footer {
    display: flex;
    padding-top: 12px;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #E5E5E5;
    font-size: 14px;
    color: #525252;
}

.pr-content {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    font-weight: 600;
}

.no-press-release {
    display: flex;
    flex-direction: column;
    padding: 2rem;
    border: 1px solid #E5E5E5;
    border-radius: 12px;
    background-color: #FAFAFA;
    gap: 20px;
    flex: 1;
}

.no-pr-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
    gap: 0.5rem;
}

.no-pr-text {
    font-size: var(--header-font-size);
    font-weight: 600;
}

.no-pr-sub-text {
    font-size: var(--normal-font-size);
    color: var(--dark-grey-color);
}

.meta-info {
    color: #ccc;
    display: flex;
    gap: 4px;
    align-items: center;
    flex-direction: row;
}

.new-pr-container {
    display: flex;
    background: black;
    flex-direction: row;
    color: var(--secondary-font-color);
    border-radius: 8px;
    align-items: center;
    gap: 8px;
    padding: 0.8rem 1.8rem;
    font-family: 'OverpassMono';

}
</style>